import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { MsalRedirectComponent } from '@azure/msal-angular';
import * as angular from 'angular';
import { Gridster, GridsterItem } from 'angular-gridster2';

import { MsalAuthService, SignalRService, UserService } from '@shared/services';

export const Ng1ModuleSystem = angular
  .module('ng1module.system', [])
  .directive('gridster', downgradeComponent({ component: Gridster }) as angular.IDirectiveFactory)
  .directive('gridsterItem', downgradeComponent({ component: GridsterItem }) as angular.IDirectiveFactory)
  .directive('appRedirect', downgradeComponent({ component: MsalRedirectComponent }) as angular.IDirectiveFactory)
  .factory('msalAuthService', downgradeInjectable(MsalAuthService) as any)
  .factory('signalRService', downgradeInjectable(SignalRService) as any)
  .factory('userServiceNg1', downgradeInjectable(UserService) as any).name;
